export const environment = {
  production: false,
  APIURL: 'http://localhost:4200'
};